import React, { useState, useEffect } from "react";
import {
  Button,
  ControlLabel,
  FormControl,
  FormGroup,
  Modal,
} from "react-bootstrap";


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

// Utiliza las variables de entorno
const conversationId = process.env.REACT_APP_CONVERSATION_ID;
const username = process.env.REACT_APP_USERNAME;
const password = process.env.REACT_APP_PASSWORD;

const filterAndSortEmotions = (face) =>
  Object.keys(face.emotions)
    .map((emotion) => ({
      emotion,
      confidence: face.emotions[emotion],
    }))
    .filter((x) => x.confidence > 0)
    .sort((a, b) => b.confidence - a.confidence);

    // const sendPersonData = async (person) => {
    //   try {
    //     var myHeaders = new Headers();
    //     myHeaders.append("Content-Type", "application/json");
    
    //     var raw = JSON.stringify({
    //       memberName: person.memberName,
    //       jobTitle: person.jobTitle,
    //       telefono: person.Phone,
    //     });
    
    //     var requestOptions = {
    //       method: 'POST',
    //       headers: myHeaders,
    //       body: raw,
    //     };
    
    //     fetch("http://localhost:5000/send-to-zapier", requestOptions)
    //       .then((response) => response.text())
    //       .then((result) => console.log(result))
    //       .catch((error) => console.log("Error:", error));
    //   } catch (error) {
    //     console.error("Failed to send person data:", error);
    //   }
    // };
    


const sendPersonData = async (person) => {
  try {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      memberName: person.memberName,
      jobTitle: person.jobTitle,
      telefono: person.Phone,
    });

    var requestOptions = {
      method: 'POST',
      mode: 'no-cors',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    fetch("https://9x7wdvxyd5.execute-api.us-east-2.amazonaws.com/dev/startdirector", requestOptions)
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log('error', error));
  } catch (error) {
    console.error("Failed to send person data:", error);
  }
};


const sendWhatsAppMessage = async (phoneNumber, memberName) => {
  try {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer EAAKBbrxkwwEBAGw9mu6RZBk2zKHLfHh5pnWX4VUBxGZC61pBmrw4UJ0ltqvqbSTdRm7MCC8EZB88QaZC3DrDonCMvQVuTrHiAGzSiLdMfxaQUMeziQH0MQ2ZBzVo82Mpu7VQZAZAZBdjU6ZCbiKEh5WODelpplieHyiVLiTyBBr1VwazkRlqPvZBtI`);

    var raw = JSON.stringify({
      messaging_product: "whatsapp",
      to: phoneNumber,
      type: "template",
      template: {
        name: "confirmacion_biometria_webinar",
        language: {
          code: "es_MX",
          policy: "deterministic",
        },
        components: [
          {
            type: "header",
            parameters: [
              {
                type: "image",
                image: {
                  link: "https://images.email-platform.com/danaconnect/biometricbanner.png",
                },
              },
            ],
          },
          {
            type: "body",
            parameters: [
              {
                type: "text",
                text: memberName,
              },
            ],
          },
        ],
      },
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    fetch("https://graph.facebook.com/v12.0/106896205535101/messages", requestOptions)
      .then((response) => response.text())
      //.then((result) => console.log(result))
      //.catch((error) => console.log('error', error));
  } catch (error) {
    console.error("Failed to send WhatsApp message:", error);
  }
};

const EngagementsSummary = ({
  detectedFaces,
  detectedPeople,
  showFaceBoundingBoxes,
  webcamCoordinates,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [currentPerson, setCurrentPerson] = useState(null);

  useEffect(() => {
    detectedPeople.forEach((person) => {
      if (person.jobTitle) {
        sendPersonData(person);
      }
    });
  }, [detectedPeople]);

  const handleShowModal = (person) => {
    setCurrentPerson(person);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleSendWhatsApp = () => {
    if (currentPerson) {
      sendWhatsAppMessage(phoneNumber, currentPerson.memberName);
      handleCloseModal();
    }
  };

  return (
    <div>
      {detectedFaces.map((face, index) => (
        <div key={index}>
          {showFaceBoundingBoxes && (
            <div
              style={{
                border: "1px solid #ef4b26",
                fontWeight: "bold",
                position: "fixed",
                height: webcamCoordinates.height * face.boundingBox.Height,
                left: webcamCoordinates.left + face.boundingBox.Left * webcamCoordinates.width,
                top: webcamCoordinates.top + face.boundingBox.Top * webcamCoordinates.height,
                width: webcamCoordinates.width * face.boundingBox.Width,
              }}
            >
              Persona #{index + 1}
            </div>
          )}
        </div>
      ))}
      {detectedPeople.map((person) => (
        <div key={person.externalImageId}>
          <p>
            <b
               style={{
                fontFamily: "Arial, sans-serif",
                color: "#fff",
                fontSize: "32px",
                marginTop: "0px",
                backgroundColor: "#4B286D",
                padding: "20px",
                borderRadius: "25px",
                lineHeight: "1.5",
                lineBreak: "auto",
              }}
            >
              ¡Hola, {person.memberName}!
            </b>
          </p>
          <p
            style={{
              fontFamily: "Arial, sans-serif",
              color: "#fff",
              fontSize: "32px",
              marginTop: "0px",
              backgroundColor: "#4B286D",
              padding: "10px",
              borderRadius: "25px",
            }}
          >
            Acabamos de registrarte para la rifa al final del evento.
          </p>
         <p
            style={{
              fontFamily: "Arial, sans-serif",
              color: "#fff",
              fontSize: "22px",
              marginTop: "-10px",
              backgroundColor: "#4B286D",
              padding: "20px",
              borderRadius: "25px",
            }}
          >
            Enviamos una confirmación a tu email: <p>{person.jobTitle}</p>
          </p>
          <Button
            onClick={() => handleShowModal(person)}
            style={{
              marginTop: "80px",
              padding: "10px 20px",
              fontSize: "28px",
              fontFamily: "Arial, sans-serif",
              backgroundColor: "#5646ff",
              color: "#fff",
              border: "none",
              borderRadius: "15px",
              lineBreak: "auto",
            }}
          >
               <FontAwesomeIcon icon={faWhatsapp} style={{ marginRight: '15px' }} />
            Enviar por WhatsApp
          </Button>
        </div>
      ))}

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Enviar también por WhatsApp</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup controlId="formPhoneNumber">
            <ControlLabel>Teléfono con código país. Ej: 18095551234</ControlLabel>
            <FormControl
              type="text"
              placeholder="Ej: 18095551234"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSendWhatsApp}>
            Enviar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EngagementsSummary;
